import React from "react";

import {
  faGitlab,
  faGithub,
  faLinkedinIn,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import myCV from "../../static/mahditahavorgar201.pdf"

const Contact = () => {
  return (
    <div className="flex items-baseline pt-5 capitalize">
      <h4 className="text-gray-500 text-base md:text-xl pr-8">LINKS</h4>
      <ul>
        <li>
          <a
            className="flex items-center text-base md:text-xl"
            rel="noreferrer"
            target="_blank"
            aria-label="Github"
            href="https://github.com/mahdiiithg"
          >
            github
            <FontAwesomeIcon className="pl-4 text-4xl" icon={faGithub} />
          </a>
        </li>
        <li>
          <a
            className="flex items-center text-base md:text-xl"
            rel="noreferrer"
            target="_blank"
            aria-label="Gitlab"
            href="https://gitlab.com/mahditahavorgar"
          >
            gitlab
            <FontAwesomeIcon className="pl-4 text-4xl" icon={faGitlab} />
          </a>
        </li>
        <li>
          <a
            className="flex items-center text-base md:text-xl"
            rel="noreferrer"
            target="_blank"
            aria-label="Instagram"
            href="https://www.instagram.com/code_thg/"
          >
            instagram
            <FontAwesomeIcon className="pl-4 text-4xl" icon={faInstagram} />
          </a>
        </li>
        <li>
          <a
            className="flex items-center text-base md:text-xl"
            rel="noreferrer"
            target="_blank"
            aria-label="Linkedin"
            href="https://www.linkedin.com/in/mahdi-tahavorgar-6146ba14b/"
          >
            linkedin
            <FontAwesomeIcon className="pl-4 text-4xl" icon={faLinkedinIn} />
          </a>
        </li>
        <li>
          <a
            className="flex items-center text-base md:text-xl"
            rel="noreferrer"
            target="_blank"
            href={myCV}
            download
          >
            MahdiTahavorgar CV
          </a>
        </li>
        <li>
          <a
            className="flex items-center text-base md:text-xl lowercase"
            rel="noreferrer"
            target="_blank"
            aria-label="Email"
            href="`mailto:mahditahavorgar@gmail.com"
          >
            mahditahavorgar@gmail.com
          </a>
        </li>
      </ul>
    </div>
  );
};

export default Contact;
